// components/cells/CellButtonWithIcon.tsx
import { Button, Box, IconButton } from "@mui/material";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import React, { useState } from "react";

interface CellButtonWithIconProps {
  params: any;
  onClick: (params: any, clickedElement: "icon" | "text") => void;
  children: React.ReactNode;
}

const CellButtonWithIcon = ({ params, onClick, children }: CellButtonWithIconProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "fit-content",
        gap: 1,
        "&:hover .email-icon": { visibility: "visible" },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Button
        variant="text"
        size="small"
        tabIndex={params.hasFocus ? 0 : -1}
        sx={{
          color: "text.primary",
          textDecoration: "underline",
          textTransform: "none",
          fontSize: "14px",
          padding: 0,
          minWidth: 0,
        }}
        onClick={() => onClick(params, "text")}
      >
        {children}
      </Button>

      <IconButton
        size="small"
        className="email-icon"
        sx={{ visibility: "hidden", padding: 0 }}
        onClick={(e) => {
          onClick(params, "icon");
        }}
      >
        <MarkEmailReadIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default CellButtonWithIcon;
